import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './components/ui/Toast';
import { warmServers, installWakeOnReturn } from './lib/serverWake';
import { initTheme } from './lib/theme';
import './index.css';
import App from './App';

// Start waking the free-tier backend + relay before React even renders, on every
// route (landing, dashboard, deep links like /verify-email). See lib/serverWake.js.
warmServers();
installWakeOnReturn();

// Light / dark appearance: follows the OS unless the user picked one (lib/theme.js).
initTheme();

// Google's OAuth provider wraps only the auth pages (components/AuthRoute.jsx), so
// its sign-in script doesn't load on the landing page (Phase 46).
//
// v7_startTransition: route changes run as React transitions, so the current page
// stays on screen while a code-split route loads instead of flashing the blank
// Suspense fallback.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter future={{ v7_startTransition: true }}>
        <AuthProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
